import axiosInstance from "../Interceptors/ResponseInterceptor";

export const getAllDomain = async () => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axiosInstance.get(`/api/domain-details`);
        //
        resolve(response.data);
      } catch (error) {
        console.error("Error in getAllDomain:", error);
        reject(error);
      }
    });
  };